/**
 * useManagedSqlDbs Hook
 *
 * Custom React Query hook for fetching managed SQL databases list.
 */

import { useQuery } from '@tanstack/react-query';
import { managedSqlDbService } from '../../../api/managed-sql-db.service';
import type { ManagedSqlDbListQuery } from '../../../types/managed-sql-db.types';

/**
 * Hook for fetching managed SQL databases
 * @param tenantId - Tenant ID
 * @param query - Optional query parameters (status, limit, lastKey)
 */
export const useManagedSqlDbs = (tenantId: string, query?: ManagedSqlDbListQuery) => {
  return useQuery({
    queryKey: ['managedSqlDbs', tenantId, query],
    queryFn: async () => {
      const result = await managedSqlDbService.listManagedSqlDbs(tenantId, query);
      return result;
    },
    enabled: !!tenantId,
    staleTime: 30 * 1000, // 30 seconds (shorter due to status changes)
  });
};
